import { MOKA_FRESH_HOST } from 'api/constants';
import arrowIcon from 'assets/images/backoffice/fresh/arrow-icon.svg';
import customerSupport from 'assets/images/backoffice/fresh/customer-support.svg';
import goFreshLogo from 'assets/images/backoffice/fresh/gofresh-logo.png';
import freshLogo from 'assets/images/backoffice/fresh/moka-fresh-logo.png';
import * as clevertapFresh from 'clevertap/fresh';
import React, { Component } from 'react';
import _ from 'lodash';
import FaqContent from './FaqContent';
import GoFresh from './GoFresh';
import './PhaseOut.css';
import WaMe from './WaMe';

class PhaseOut extends Component {
  state = {
    desktopBanner:
      'https://moka-fresh-asset-public.s3-ap-southeast-1.amazonaws.com/backoffice/banner-info.png',
    mobileBanner:
      'https://moka-fresh-asset-public.s3-ap-southeast-1.amazonaws.com/backoffice/banner-info-mobile.png',
    bannerContent:
      'https://moka-fresh-asset-public.s3-ap-southeast-1.amazonaws.com/backoffice/banner-product-fresh.png',
    zendesk:
      'https://mokaposhelp.zendesk.com/hc/id/sections/360003335333-Moka-Fresh',
    isMobile: false,
  };

  componentDidMount() {
    this.updateResponsive();
    window.addEventListener('resize', this.updateResponsive);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateResponsive);
  }

  updateResponsive = _.debounce(() => {
    const mql = window.matchMedia('(max-width: 991px)');
    this.setState({
      isMobile: mql.matches,
    });
  }, 50);

  startShopping = () => {
    clevertapFresh.startShopping();
    window.location.href = MOKA_FRESH_HOST;
  };

  render() {
    const {
      desktopBanner,
      mobileBanner,
      bannerContent,
      zendesk,
      isMobile,
    } = this.state;
    const banner = isMobile ? mobileBanner : desktopBanner;
    const { isEligible } = this.props;

    return (
      <div className="mfr-phaseout">
        {!isMobile && (
          <div className="flex items-center group-logo">
            <img src={freshLogo} className="logo-join" />
            <p>X</p>
            <img src={goFreshLogo} className="logo-join" />
          </div>
        )}
        <div className="banner-info">
          <img src={banner} />
        </div>
        <div className="phase-content">
          <div className="left">
            <img src={bannerContent} className="banner-content" />
          </div>
          <div className="right">
            <div className="group-join">
              <div className="gofresh-benefit">
                <ul>
                  <li>Harga Bersaing</li>
                  <li>Kualitas dan ketersediaan bahan baku terjamin</li>
                  <li>Pengaturan bahan baku dan keuangan yang praktis</li>
                  <li>Pengiriman yang praktis</li>
                  <li>Kemudahan Proses Pemesanan</li>
                </ul>
              </div>
            </div>
            <GoFresh mobile={isMobile} isEligible={isEligible} />
            {!isMobile && <WaMe />}
          </div>
        </div>
        <div>
          <div className="faq-card">
            <div className="flex items-center faq-header">
              <img src={customerSupport} />
              <p>Quick Frequently Asked Questions</p>
            </div>
            <div className="faq-content-wrapper">
              <FaqContent />
            </div>
            <div className="faq-footer">
              <a target="_blank" href={zendesk}>
                <p>Lihat Selengkapnya</p>
              </a>
              <img src={arrowIcon} />
            </div>
          </div>
          {isMobile && <WaMe mobile />}
        </div>
      </div>
    );
  }
}

export default PhaseOut;
